import { type InvestmentBalance } from 'investments/common/entities'

export function getBucketBalanceSupportMessage(balance?: InvestmentBalance | null): string | null {
  if (!balance) return null
  if (balance.netAmount === 0) return 'Volte a guardar no objetivo e faça o seu dinheiro render mais que na poupança!'
  if (balance.returnAmount === 0)
    return 'Você recebe o primeiro rendimento 30 dias depois de guardar o dinheiro, aguarde.'
  return null
}
